export { default as MiniProductCard } from './MiniProductCard';
export type { MiniProductCardProps } from './MiniProductCard';

